/* import __COLOCATED_TEMPLATE__ from './confirm-close-account.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();